


import Formulario from '../../components/mapas/provincia/juego1'
import React, { useEffect, useState } from "react";
import {
  useMediaQuery,
  useTheme,
} from "@mui/material";

export default function Paginas() {
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("md"));


   
            return (
                <>
           {isMatch ? <>
            <div style={{ position: 'absolute', top: 0, left: -70, width: '100%', height: '100%',transform:"scale(0.5)" }} >
    
    <Formulario/>

</div>
           
           </>:<>
           <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} >
    
                <Formulario/>
          
     </div>
     </>}
              
                
     
                </>
           
            );
        
        }